import ChooseTrackSection from './ChooseTrackSection'
import CompanySpecificSection from './CompanySpecificSection'
import PlacementHeroSection from './PlacementHeroSection'

const PlacementPrep = () => {
  return (
    <div>
      <PlacementHeroSection />
      <ChooseTrackSection />
      <CompanySpecificSection />
    </div>
  )
}

export default PlacementPrep
